import { ADMIN_SEARCH_FILTER_TYPE } from '@joc/api-gateway';
import { OPPORTUNITIES_TABS } from 'shared/components/OppListContent';

export const SUPER_ADMIN_POSTS_TAB = 'POSTS' as const;

export type SuperAdminOpportunitiesTab = OPPORTUNITIES_TABS | 'PRIVATE' | typeof SUPER_ADMIN_POSTS_TAB;

export const parseTabFromSearch = (search: string): SuperAdminOpportunitiesTab => {
	if (search.includes('private')) return 'PRIVATE';
	if (search.includes('past')) return OPPORTUNITIES_TABS.PAST;
	if (search.includes('upcoming')) return OPPORTUNITIES_TABS.UPCOMING;
	if (search.includes('posts')) return SUPER_ADMIN_POSTS_TAB;
	if (search.includes('manual')) return OPPORTUNITIES_TABS.MANUAL;
	if (search.includes('challenge')) return OPPORTUNITIES_TABS.CHALLENGE;
	return OPPORTUNITIES_TABS.ALL;
};

export const mapTabToOpportunityFilterType = (
	tab: SuperAdminOpportunitiesTab
): ADMIN_SEARCH_FILTER_TYPE | undefined => {
	switch (tab) {
		case OPPORTUNITIES_TABS.ALL:
			return ADMIN_SEARCH_FILTER_TYPE.ALL;
		case OPPORTUNITIES_TABS.UPCOMING:
			return ADMIN_SEARCH_FILTER_TYPE.UPCOMING;
		case OPPORTUNITIES_TABS.CHALLENGE:
			return ADMIN_SEARCH_FILTER_TYPE.CHALLENGE;
		case OPPORTUNITIES_TABS.MANUAL:
			return ADMIN_SEARCH_FILTER_TYPE.SOLO;
		case OPPORTUNITIES_TABS.PAST:
			return ADMIN_SEARCH_FILTER_TYPE.PAST;
		case 'PRIVATE':
			return ADMIN_SEARCH_FILTER_TYPE.PRIVATE;
		case SUPER_ADMIN_POSTS_TAB:
			return undefined;
		default:
			return ADMIN_SEARCH_FILTER_TYPE.ALL;
	}
};

export const toTabSearch = (tab: SuperAdminOpportunitiesTab): string =>
	tab !== OPPORTUNITIES_TABS.ALL ? `?${tab.toLowerCase()}` : '';
